// extracted by mini-css-extract-plugin
module.exports = {"bgImg":"Landing_bgImg__3sp2e","bgImg2":"Landing_bgImg2__tOq8W","bgImg3":"Landing_bgImg3__27RXM"};